/**
 * Removes the "https://checkout.thameenlondon.com" from the product handle
 */

/**
 * First we need to get the checkout url from the product handle
 * Then we need to remove the checkout url from the product handle
 * Then we need to return the product handle
 */

export function parseProductHandle(handle) {
  const checkoutUrl = handle.split('/').slice(0, 4).join('/');
  const productHandle = handle.replace(checkoutUrl + '/', '');
  return productHandle;
}
